import { withInstall } from '../../utils';
import TextButton from './src/text-button.vue';
import TextButtonGroup from './src/text-button-group.vue';

export const ITextButton = withInstall(TextButton);
export const ITextButtonGroup = withInstall(TextButtonGroup);

export default {
  ITextButton,
  ITextButtonGroup,
};
